import React, { useState } from 'react';
import styles from './AutoCompleteInput.module.css';

const AutoCompleteInput = ({ filterText, setFilterText, whenHotpleClicked, suggestions }) => {
  const [showSuggestions, setShowSuggestions] = useState(false);

  const whenInputFocused = () => {
    setShowSuggestions(true);
  };

  const whenInputBlured = () => {
    setTimeout(() => setShowSuggestions(false), 100);
  };

  return (
    <div className={styles.autocompleteWrapper}>
      <img className={filterText.length>0 ? styles.iconsearchActive : styles.iconsearch} alt="" src="images/search.svg" />
      <input
        className={styles.label5}
        type="text"
        value={filterText}
        onChange={(e) => {
          setFilterText(e.target.value);
          setShowSuggestions(true);
        }}
        placeholder="이름으로 핫플 검색"
        autoComplete="off"
        onFocus={() => whenInputFocused()}
        onBlur={() => whenInputBlured()}
        onKeyDown={(e) => {
            if (e.key === 'Enter') {
              e.target.blur();
            }
        }}
      />
      {showSuggestions && filterText && suggestions.length > 0 && (
        <ul className={styles.suggestionsList}>
          {suggestions.slice(0,5).map((hotple, index) => (
            <li
              key={index}
              className={styles.suggestionItem}
              onClick={() => {
                setFilterText(hotple.name);
                setShowSuggestions(false);
                whenHotpleClicked(hotple)
              }}
            >
              {hotple.name}
            </li>
          ))}
        </ul>
      )}
    </div>
  );
};

export default AutoCompleteInput;